var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"size":_vm.size},on:{"change":_vm.handleChange},model:{value:(_vm.currValue),callback:function ($$v) {_vm.currValue=$$v},expression:"currValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }